<template>
  <f7-page ptr @ptr:refresh="refreshData" @page:reinit="getTree">
    <f7-navbar :no-shadow="true">
      <f7-nav-left color-theme="white" back-link="返回" back-link-url="/">
      </f7-nav-left>
      <f7-nav-title style="font-size: 1rem; z-index: 600;">
        <span v-if="taskTree.path && taskTree.path.length > 0">
          {{ taskTree.path[taskTree.path.length - 1] }}
        </span>
        <span v-else>{{ taskTree.name }}</span>
      </f7-nav-title>
    </f7-navbar>
    <div class="sub-navbar">
      <f7-row>
        <f7-col>
          <f7-icon icon="cicon-renwu" size="1rem">
            {{ taskTree.childNum || 0 }}个
          </f7-icon>
        </f7-col>
        <f7-col>
          <f7-icon icon="cicon-duiwu" size="1rem">
            {{ taskTree.companyNum || 0 }}队
          </f7-icon>
        </f7-col>
        <f7-col>
          <f7-icon icon="cicon-gongren" size="1rem">
            {{ taskTree.clockInNum || 0 }}人
          </f7-icon>
        </f7-col>
      </f7-row>
    </div>
    <div class="has-content">
      <f7-list virtual-list style="margin-top: 0rem;">
        <li>
          <ul v-for="task in taskTree.tree" :key="task.id">
            <hierarchical-task
              :root-id="projectId"
              :task="task"
              :task-id.sync="taskId">
            </hierarchical-task>
          </ul>
        </li>
      </f7-list>
    </div>
    <f7-fab position="right-bottom" slot="fixed">
      <f7-icon icon="add" style="width: 3rem; text-align: center;">
        <div style="font-size: 0.9rem;">拆分<br/>项目</div>
      </f7-icon>
      <f7-icon f7="close"></f7-icon>
      <f7-fab-buttons position="top">
        <f7-fab-button @click="add">
          <div style="font-size: 0.8rem;">普通<br/>任务</div>
        </f7-fab-button>
        <f7-fab-button @click="addAssist">
          <div style="font-size: 0.8rem;">辅助<br/>任务</div>
        </f7-fab-button>
      </f7-fab-buttons>
    </f7-fab>
    <f7-popover
      id="popverMenu"
      :animate="false"
      :closeByBackdropClick="true"
      :closeByOutsideClick="true"
      style="width: 8.5rem;">
      <div class="list">
        <ul>
          <li>
            <a
              href="#"
              class="item-link list-button"
              style="line-height: 2rem; text-align: left;"
              @click="split">
              <f7-icon icon="cicon-chaifen" size="0.8rem"></f7-icon>
              <span class="popverMenu-button-text">&nbsp;拆分任务</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="item-link list-button"
              style="line-height: 2rem; text-align: left;"
              @click="insertSplit">
              <f7-icon icon="cicon-charurenwu" size="0.8rem"></f7-icon>
              <span class="popverMenu-button-text">&nbsp;插入任务</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="item-link list-button"
              style="line-height: 2rem; text-align: left;"
              @click="splitAssist">
              <f7-icon icon="cicon-chaifenfuzhurenwu" size="0.8rem"></f7-icon>
              <span class="popverMenu-button-text">&nbsp;拆分辅助任务</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="item-link list-button"
              style="line-height: 2rem; text-align: left;"
              @click="insertSplitAssist">
              <f7-icon icon="cicon-charufuzhurenwu" size="0.8rem"></f7-icon>
              <span class="popverMenu-button-text">&nbsp;插入辅助任务</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="item-link list-button"
              style="line-height: 2rem; text-align: left;"
              @click="deleteTask">
              <f7-icon icon="cicon-shanchu" size="0.8rem"></f7-icon>
              <span class="popverMenu-button-text">&nbsp;删除</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="item-link list-button"
              style="line-height: 2rem; text-align: left;"
              @click="upLevelTask">
              <f7-icon icon="cicon-xiangshang" size="0.8rem"></f7-icon>
              <span class="popverMenu-button-text">&nbsp;升级</span>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="item-link list-button"
              style="line-height: 2rem; text-align: left;"
              @click="downLevelTask">
              <f7-icon icon="cicon-xiangxia" size="0.8rem"></f7-icon>
              <span class="popverMenu-button-text">&nbsp;降级</span>
            </a>
          </li>
        </ul>
      </div>
    </f7-popover>
    <div style="height: 5rem;"></div>
  </f7-page>
</template>
<script>
import { toGroupConversation } from '@/util/native';
import bus from '@/util/bus';
import { createToast } from '@/util/compUtils';
import { getProjectTreeList, upProject, downProject, deleteProject } from '@/api/project/project';
import HierarchicalTask from '@/components/HierarchicalTask';

export default {
  props: ['projectId'],
  components: {
    HierarchicalTask,
  },
  data() {
    return {
      taskId: '',
      taskName: '',
      taskParentId: '',
      taskPerms: '',
      taskTree: {},
      perms: {},
    };
  },
  created() {
    bus.$on('taskPopMenu', (id, name, parentId, perms, event) => {
      this.taskId = id;
      this.taskName = name;
      this.taskParentId = parentId;
      this.taskPerms = perms || {};
      this.$f7.popover.open('#popverMenu', event.target, true);
    });
  },
  mounted() {
    this.getTree();
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getTree()]).then(() => done());
    },
    getTree() {
      getProjectTreeList({ projectId: this.projectId }).then((result) => {
        if (result.code === 0) {
          this.taskTree = Object.assign({ pathDisplay: false }, result.data);
          this.perms = result.perms || {};
        }
      });
    },
    add() {
      if (!this.perms.projectSplit) {
        createToast(this, '您无权限拆分任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7router.navigate(`/project/split/?title=添加任务&parentId=${this.projectId}&rootId=${this.projectId}`);
    },
    addAssist() {
      if (!this.perms.projectSplitAssist) {
        createToast(this, '您无权限拆分辅助任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7router.navigate(`/project/addAssist/?title=添加辅助任务&parentId=${this.projectId}&rootId=${this.projectId}`);
    },
    split() {
      if (!this.taskPerms.projectSplit) {
        createToast(this, '您无权限拆分任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7router.navigate(`/project/split/?title=拆分任务&parentId=${this.taskId}&rootId=${this.projectId}`);
    },
    insertSplit() {
      if (!this.taskPerms.projectInsert) {
        createToast(this, '您无权限插入任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7router.navigate(`/project/split/?title=插入任务&parentId=${this.taskParentId}&rootId=${this.projectId}&preProjectId=${this.taskId}`);
    },
    splitAssist() {
      if (!this.taskPerms.projectSplitAssist) {
        createToast(this, '您无权限拆分辅助任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7router.navigate(`/project/addAssist/?title=拆分辅助任务&parentId=${this.taskId}&rootId=${this.projectId}`);
    },
    insertSplitAssist() {
      if (!this.taskPerms.projectInsertAssist) {
        createToast(this, '您无权限插入辅助任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7router.navigate(`/project/addAssist/?title=插入辅助任务&parentId=${this.taskParentId}&rootId=${this.projectId}&preProjectId=${this.taskId}`);
    },
    toMsgList() {
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7router.navigate(`/project/msgList/${this.taskId}?title=通知-${this.taskName}`);
    },
    toGroupChat() {
      this.$f7.popover.get('#popverMenu').close(true);
      toGroupConversation(this.taskId);
    },
    deleteTask() {
      if (!this.taskPerms.projectDelete) {
        createToast(this, '您无权限删除任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7.dialog.confirm('确认要删除任务吗？', '温馨提示', () => {
        deleteProject({ ids: [this.taskId] }).then((result) => {
          if (result.code === 0) {
            createToast(this, '删除任务成功');
            this.getTree();
          }
        });
      });
    },
    upLevelTask() {
      if (!this.taskPerms.projectMove) {
        createToast(this, '您无权限升级任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7.dialog.confirm('确认要升级任务吗？', '温馨提示', () => {
        upProject([{ projectId: this.taskId }]).then((result) => {
          if (result.code === 0) {
            createToast(this, '升级任务成功');
            this.getTree();
          }
        });
      });
    },
    downLevelTask() {
      if (!this.taskPerms.projectMove) {
        createToast(this, '您无权限降级任务');
        return;
      }
      this.$f7.popover.get('#popverMenu').close(true);
      this.$f7.dialog.confirm('确认要降级任务吗？', '温馨提示', () => {
        downProject([{ projectId: this.taskId }]).then((result) => {
          if (result.code === 0) {
            createToast(this, '降级任务成功');
            this.getTree();
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .sub-navbar {
     background-color: #D3E3F9;
     color: #000000;
     text-align: center;
     height: 3rem;
     line-height: 3rem;
  }

  .popverMenu-button-text {
    font-size: 0.8rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/project/tree.vue